import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getCensorRatingById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { CensorRatingIcon } from '../../../../subcomponents/censor-rating-icon/censor-rating-icon';
import { Heading, HeadingLevel } from '../../../../subcomponents/heading';
const b = bemClassBuilder('v-film-title');
export const FilmTitleUI = observer(props => {
    const i18n = useI18n();
    const { film, headingLevel, censorRatingIconCdnOptions } = props;
    const censorRating = film.censorRatingId ? getCensorRatingById(film.censorRatingId) : undefined;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(Heading, Object.assign({ level: headingLevel || HeadingLevel.H1, className: b.element('text') }, { children: i18n.translatable(film.title) })), censorRating && (_jsx(CensorRatingIcon, { className: b.element('censor-rating'), censorRating: censorRating, cdnOptions: censorRatingIconCdnOptions }))] })));
});
FilmTitleUI.displayName = 'FilmTitleUI';
export const FilmTitleSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
FilmTitleSkeleton.displayName = 'FilmTitleSkeleton';
